<template>
  <div>
    <page-header
      title="Shipment Timeline"
      breadcrumb="Dashboard > Bookings & Shipments  > Trackings"
    />
    <div class="bg-white py-3">
      <shipment-table />
      <shipment-timeline />
      <TimelineShippingDetails/>
    </div>
  </div>
</template> 

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import ShipmentTimeline from "@/components/3pl/IncidentAndRequest/ShippmentTimeline";
import ShipmentTable from "@/components/3pl/IncidentAndRequest/ShipmentTable";
import TimelineShippingDetails from "@/components/3pl/IncidentAndRequest/TimelineShippingDetails.vue";

export default {
  components: {
    PageHeader,
    ShipmentTable,
    ShipmentTimeline,
    TimelineShippingDetails
  },
  mounted() {
    this.getIncidentTimelineId()
  },
  methods: {
    async getIncidentTimelineId(){
        try {
          let response =  await this.$_incedenttimelineById(this.$route.params.id);
          console.log(response)
        } catch (error) {
          //
        }
    }
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
</style>